import { inject, Injectable } from '@angular/core';
import { SharedApiService } from '../../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private endpoint1 = `Post/GetDepartmentPostsCount`
  private endpoint2 = `Tag/GetTags`
  private endpoint3 = `Post/GetLatestPosts`


  private sharedApiService = inject(SharedApiService)

  getAllDepartments() {
    return this.sharedApiService.getAll(this.endpoint1);
  }

  getAllTags(filter?: any) {
    return this.sharedApiService.getWithFilter(this.endpoint2, filter);
  }

  getLatestPosts(filter: any) {
    return this.sharedApiService.getWithFilter(this.endpoint3, filter);
  }
}
